import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";

/**
 * 셀 값 + 조회 버튼을 렌더. 버튼 클릭 시 cellRendererParams로 넘어온
 * onOpenPopup(node)를 호출해 페이지 레벨 팝업을 열도록 위임한다.
 * (레거시 wingui의 `button: "action"` + onCellButtonClicked 대응)
 *
 * 사용: columnDef에
 *   cellRenderer: CodePickerRenderer,
 *   cellRendererParams: { onOpenPopup: (node) => setPopup({ open: true, node }) }
 *
 * `hideButtonWhenSaved: true`를 추가하면 저장된 행(`data.id` 존재)에서 조회 버튼을 아예 숨긴다
 * (레거시 `buttonVisibleCallback: isNewGridButtonVisible` 대응 — 신규 행에서만 FK 참조를 재선택 가능,
 * 저장 후에는 값 확정. fp-master-screen-guide.md §3-4 참고).
 *
 * `requiredField: "resourceCd"`처럼 다른 필드명을 넣으면, 그 필드가 비어있는 동안에도 버튼을
 * 숨긴다(레거시 `isGridResourceButtonVisible` 대응 — "자원을 먼저 선택해야 전/후 공정을 고를 수
 * 있다" 같은 2단계 의존 관계). `hideButtonWhenSaved`와 함께 쓰면 두 조건이 AND로 결합된다.
 */
const CodePickerRenderer = (props) => {
  const value = props.valueFormatted ?? props.value ?? "";
  const { onOpenPopup, hideButtonWhenSaved, requiredField } = props;
  const isLocked = (hideButtonWhenSaved && !!props.data?.id) || (requiredField && !props.data?.[requiredField]);

  const openPopup = () => {
    if (isLocked || props.node?.rowPinned || typeof onOpenPopup !== "function") return;
    onOpenPopup(props.node);
  };

  return (
    <Box sx={{ display: "flex" }} onDoubleClick={openPopup}>
      <Box component="span">{value}</Box>
      {!isLocked && (
        <Box component="span" sx={{ ml: "auto" }}>
          <IconButton aria-label="select" size="small" sx={{ verticalAlign: "baseline" }} onClick={openPopup}>
            <SearchIcon sx={{ width: "15px", height: "15px" }} />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default CodePickerRenderer;
